import { render } from "./CertificationBanner.vue?vue&type=template&id=bf648ea0&scoped=true"
import script from "./CertificationBanner.vue?vue&type=script&lang=js"
export * from "./CertificationBanner.vue?vue&type=script&lang=js"

import "./CertificationBanner.vue?vue&type=style&index=0&id=bf648ea0&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf648ea0"]])

export default __exports__